<script setup lang="ts">
import { FiltersBar } from '@shared/ui/filters'

import { useButtonFiltersSubmit } from '../../model/shift-control/button-filters-submit.hook'
import { useButtonFiltersClear } from '../../model/shift-control/button-filters-clear.hook'
import SelectShiftFilter from './SelectShiftFilter.vue'
import SwitcherSlotsTracker from './SwitcherSlotsTracker.vue'

defineOptions({
  name: 'FiltersSlotsTracker',
})

const { setSubmit } = useButtonFiltersSubmit()
const { disabled: isBusy, setClear } = useButtonFiltersClear()
</script>

<template>
  <FiltersBar
    class="box-filters"
    :loading="isBusy"
    @click:submit="setSubmit"
    @click:clear="setClear"
  >
    <template #fields>
      <SwitcherSlotsTracker />
      <div class="box-filters__reservation">
        <SelectShiftFilter type="reservation-type" />
      </div>
      <div class="box-filters__slot">
        <SelectShiftFilter type="slot-status" />
      </div>
      <div class="box-filters__sort">
        <SelectShiftFilter type="sort-by" />
      </div>
    </template>
  </FiltersBar>
</template>

<style scoped lang="scss" src="./FiltersSlotsTracker.scss" />
